import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledCertificateRequestSent';

export const CertificateRequestSent = () => {
    const { t, setModal } = useCXI();

    return (
        <Styled.CertificateRequestSent as={Container.Slim}>
            <Container.Head>
                <Styled.Icons>
                    <span className="icon fal fa-award" aria-hidden="true" />
                </Styled.Icons>
            </Container.Head>

            <Container.Body>
                <Styled.Title>{t('modal.CertificateRequestSent.title')}</Styled.Title>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.CertificateRequestSent>
    );
};
